var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperlessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.730469,
    y: 0.301453,
    width: 64,
    height: 64,
    rx: 18.6182,
    fill: "#E8F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3667 33.5814C44.3667 36.5904 43.1714 39.4762 41.0437 41.6039C38.916 43.7316 36.0302 44.9269 33.0212 44.9269C30.0122 44.9269 27.1265 43.7316 24.9988 41.6039C22.8711 39.4762 21.6758 36.5904 21.6758 33.5814C21.6758 25.6396 29.6176 15.4287 33.0212 15.4287C36.4249 15.4287 44.3667 25.6396 44.3667 33.5814Z",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0215 26.7742V49.4651",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6942 33.5815C38.6942 34.3264 38.5475 35.0641 38.2624 35.7523C37.9773 36.4406 37.5595 37.0659 37.0327 37.5927C36.5059 38.1194 35.8806 38.5373 35.1923 38.8224C34.5041 39.1074 33.7664 39.2542 33.0215 39.2542",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0216 34.716C31.818 34.716 30.6637 34.2378 29.8126 33.3868C28.9615 32.5357 28.4834 31.3814 28.4834 30.1778",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperlessIcon);
export default __webpack_public_path__ + "static/media/paperless-icon.d320fe70bae1b0da5f71f592f028ca9a.svg";
export { ForwardRef as ReactComponent };